import { useState } from "react";
import { Button } from "styles/Button";
import { CreateTemplateModal } from "./components/CreateTemplateModal";

export function CreateTemplate() {
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    return (
        <>
            <div>
                <Button onClick={() => setIsCreateModalOpen(true)}>
                    Criar template
                </Button>
            </div>
            <CreateTemplateModal
                isOpen={isCreateModalOpen}
                onRequestClose={() => setIsCreateModalOpen(false)}
            />
        </>
    );
}
